export const SET_AUTH_USER = "auth/authUser/SET";
export const CLEAR_AUTH_USER = "auth/authUser/CLEAR";

export const SET_AUTH_ERROR = "auth/error/SET";
export const CLEAR_AUTH_ERROR = "auth/error/CLEAR";
